<template>
	<span>
		<b-nav v-if="showNav">
			<b-nav-item-dropdown id="my-nav-dropdown " text="ENUM" toggle-class="nav-link-custom">
				<template slot="button-content">
					<i class="fa pr-2 fa-globe text-danger"></i>
					<span class="nav-link-text">ENUM <b class="caret"></b></span>
				</template>
	
				<slot v-for="(item, index) in links" name="title">
					<b-dropdown-item :to="item.link" :title="item.description" b-v-tooltip.hover>
						<i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
						{{ item.name }}
					</b-dropdown-item>
				</slot>
			</b-nav-item-dropdown>
		</b-nav>
	</span>
</template>
<script>

export default {
  name: 'top-enum-dynamic-group',
  computed: {
    links() {
      return this.$store.getters["getLinksByGroup"]('ENUM')
    },
    showNav() {
      return this.$store.getters["getLinksByGroup"]('ENUM').length > 0
    },
  },
}
</script>
